module.exports = __webpack_public_path__ + "static/img/factory.6cbd31e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/factory.jpg
// module id = D4Q/
// module chunks = 16